// @flow

import {
  getActivePdbId,
} from '../../../pdb/selectors';
import {
  getReducer,
} from './main';
import type { ActivesState as State } from '../types';
import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';
import type { Ratio } from '../../../../types/pdb';

type GlobalState = {
  configuration: ConfigState,
  pdb: PdbState,
  orderForm: OrderFormState,
};

type ActiveRatio = $PropertyType<State, 'ratio'>;
export const getRatioFromActives = (state: GlobalState, pdbId?: ?string) => {
  const selectedPdbId = pdbId || getActivePdbId(state);
  const reducer: ActiveRatio = getReducer(state).ratio;
  return reducer[selectedPdbId] || null;
};

export const getRatio = (state: GlobalState, pdbId?: ?string): Ratio => {
  const value = getRatioFromActives(state, pdbId);
  return typeof value === 'number' ? value : 1;
};

export default null;
